import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';

import convertTimeFormat from '@/helper/convertTimeFormat';

const todayIndex = new Date().getDay();

const Hours = (props: any) => {
  const { openHours, storeHours } = props;
  const gateAccessDaysOfWeek = Object.keys(openHours);
  const { locale }: any = useRouter();

  const renderRow = (dayName: string, dayIndex: number) => (
    <tr className={todayIndex === dayIndex ? 'active-hour' : ''} key={dayIndex}>
      <td>
        <FormattedMessage id={`shortDays.${dayName}`} />
      </td>
      <td>
        {openHours?.[dayName] ? (
          convertTimeFormat(openHours?.[dayName], locale)
        ) : (
          <FormattedMessage id="text.closed" />
        )}
      </td>
      <td>
        {storeHours?.[dayName] ? (
          convertTimeFormat(storeHours?.[dayName], locale)
        ) : (
          <FormattedMessage id="text.closed" />
        )}
      </td>
    </tr>
  );

  return (
    <table className="table sv-hours-revamp-table sv-store-hours-bold text-center mb-0">
      <thead>
        <tr className="align-middle">
          <th scope="col">
            <FormattedMessage id="days" />
          </th>
          <th scope="col">
            <FormattedMessage id="gateHours" />
          </th>
          <th scope="col">
            <FormattedMessage id="officeHours" />
          </th>
        </tr>
      </thead>
      <tbody>
        {gateAccessDaysOfWeek.map(
          (day, index) => day !== 'id' && renderRow(day, index)
        )}
      </tbody>
    </table>
  );
};

export default Hours;
